export default __webpack_public_path__ + "static/media/install.9656c11d.jpg";